import React from 'react';
import theme, { FontWeight, Size } from '../../../styles/theme.mjs';
import { formatTime } from '../../../utils/formatTime.mjs';
import { LiveIcon } from '../../Basic/Icons/ButtonIcons/ButtonIcons.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';

const Playhead = ({ isLive, currentTime, duration }) => {
    return isLive ? (React.createElement(FlexContainer, { justifyContent: "center", gap: "4px", className: "live-playhead" },
        React.createElement(LiveIcon, { color: theme.colors.mist }),
        React.createElement(TextComponent, { tag: "p", size: Size.Micro, color: theme.colors.mist, fontWeight: FontWeight.Medium }, "LIVE"))) : (React.createElement(TextComponent, { tag: "p", size: Size.Micro, color: theme.colors.mist, fontWeight: FontWeight.Medium, className: "playhead" },
        formatTime(currentTime),
        " / ",
        formatTime(duration)));
};

export { Playhead as default };
//# sourceMappingURL=Playhead.mjs.map
